import axios from '../../../lib/axios';
import React, { useEffect, useState } from 'react';
import { SuppliesMainGroupName } from '../../../models/suppliesMain';
import {
  MASTER_MAIN_GROUP_FIND_MANY,
  MASTER_MAIN_GROUP_DELETE,
  MAIN_GROUP_FIND_MANY,
  MAIN_GROUP_DELETE,
} from '../../../lib/endpoints/category';
import { MerChantModel } from '../../../models/merChantModel';
import { MERCHANT_STORE_FIND_MANY } from '../../../lib/endpoints/merchant';
import { MainGroupModel } from '../../../models/mainGroup';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

const useCategoryController = () => {
  const [data, setData] = useState<SuppliesMainGroupName[]>([]);

  const [dataMainGroup, setDataMainGroup] = useState<MainGroupModel[]>([]);
  const [dataMasterMainGroup, setDataMasterMainGroup] = useState<SuppliesMainGroupName[]>([]);

  const [selectedMainGroup, setSelectedMainGroup] = useState<MainGroupModel>(null!);
  const [selectedDeleteId, setSelectedDeleteId] = useState<string>('');
  const [selectedMainCategoryId, setSelectedMainCategoryId] = useState<SuppliesMainGroupName>(
    null!
  );
  const [openDeleteForm, setOpenDeleteForm] = useState<boolean>(false);
  const [dataMerchants, setDataMerchants] = useState<MerChantModel[]>([]);
  const [merchant, setMerchant] = useState<string>(null!);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [openMainCategory, setOpenMainCategory] = useState<boolean>(false);

  const [loadingButtonDelete, setLoadingButtonDelete] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [searchValue, setSearchValue] = useState<string>('');

  const roleAdmin = useSelector((state: RootState) => state?.auth?.data?.role?.role_type);
  const assignMerchantToAdmin = useSelector((state: RootState) => state?.auth?.data?.merchants);

  const handleFetchDataMainCategory = async () => {
    try {
      setLoading(true);
      const resGetMerchants = await axios.get(MERCHANT_STORE_FIND_MANY);
      if (resGetMerchants?.data?.length > 0) {
        setMerchant(resGetMerchants?.data[0]?.id);
        setDataMerchants(resGetMerchants?.data);
        const resMasterMainGroup = await axios.post(MASTER_MAIN_GROUP_FIND_MANY);
        setDataMasterMainGroup(resMasterMainGroup?.data);
        const res = await axios.post(MAIN_GROUP_FIND_MANY, {
          filter: {
            merchant_id: resGetMerchants?.data[0]?.id,
          },
        });
        setDataMainGroup(res?.data?.data);
      }
    } catch (err) {
    } finally {
      setLoading(true);
    }
  };

  const handleGetDataMainGroup = async () => {
    try {
      setLoading(true);
      const resGetMerchants = await axios.get(MERCHANT_STORE_FIND_MANY);
      if (resGetMerchants?.data?.length > 0) {
        const matchingMerchants = resGetMerchants.data.filter((merchant: any) =>
          assignMerchantToAdmin?.includes(merchant?.id)
        );
        if (roleAdmin === 'SUPER_ADMIN') {
          setMerchant(resGetMerchants?.data[0]?.id);
          setDataMerchants(resGetMerchants?.data);
        } else if (roleAdmin === 'ADMIN') {
          if (matchingMerchants.length > 0) {
            setMerchant(matchingMerchants[0].id);
            setDataMerchants(matchingMerchants);
          }
        }
        const resMasterMainGroup = await axios.post(MASTER_MAIN_GROUP_FIND_MANY);
        setDataMasterMainGroup(resMasterMainGroup?.data);
        const res = await axios.post(MAIN_GROUP_FIND_MANY, {
          filter: {
            merchant_id: resGetMerchants?.data[0]?.id,
          },
        });
        setDataMainGroup(res?.data?.data);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoadingButtonDelete(true);
    try {
      await axios.delete(`${MAIN_GROUP_DELETE}?id=${selectedDeleteId}`);
      // await handleFetchDataMainCategory();
      setDataMainGroup(dataMainGroup?.filter((item) => item?.id !== selectedDeleteId));
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert('Server error please try again');
      }
    } finally {
      setLoadingButtonDelete(false);
      handleCloseDeleteForm();
    }
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleOpenEdit = (id: string) => {
    setOpenMainCategory(true);
    const getEditData: SuppliesMainGroupName = data.filter((item) => item.id === id)[0];
    setSelectedMainCategoryId(getEditData);
  };

  const handleOpenDelete = (id: string) => {
    setOpenDeleteForm(true);
    setSelectedDeleteId(id);
  };

  const handleCloseDeleteForm = () => {
    setOpenDeleteForm(false);
  };

  const handleOpenAddCategory = () => {
    setOpenMainCategory(!openMainCategory);
  };
  const handleCloseAddCategory = () => {
    setOpenMainCategory(false);
  };

  const handleOpenForm = (id: string) => {
    setOpenForm(!openForm);
    const selectedData = dataMainGroup.filter((item) => item.id === id)[0];
    setSelectedMainGroup(selectedData);
  };
  const handleCloseForm = () => {
    setOpenForm(false);
  };

  const handleMerchantChange = async (e: any) => {
    try {
      setLoading(true);
      const res = await axios.post(MAIN_GROUP_FIND_MANY, {
        filter: {
          merchant_id: e.target.value,
        },
      });
      setDataMainGroup(res?.data?.data);
      setMerchant(e.target.value);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const handleRefetchData = async () => {
    const res = await axios.post(MAIN_GROUP_FIND_MANY, {
      filter: {
        merchant_id: merchant,
      },
    });
    setDataMainGroup(res?.data?.data);
    setMerchant(merchant);
  };

  useEffect(() => {
    // console.log('loading=', loading);
  }, [loading]);

  //filter Data
  const filterData: MainGroupModel[] = dataMainGroup;

  const isSearchNotFound: boolean = !filterData.length && !!searchValue;

  useEffect(() => {
    handleGetDataMainGroup();
  }, []);

  return {
    loadingButtonDelete,
    handleDelete,
    handleOpenDelete,
    openDeleteForm,
    handleCloseDeleteForm,
    openForm,
    handleCloseForm,
    handleOpenForm,
    loading,
    openMainCategory,
    handleOpenAddCategory,
    handleCloseAddCategory,
    selectedDeleteId,
    selectedMainGroup,
    searchValue,
    handleSearch,
    filterData,
    isSearchNotFound,
    handleOpenEdit,
    handleFetchDataMainCategory,
    selectedMainCategoryId,
    onSetSelectedMain: (newValue: SuppliesMainGroupName) => setSelectedMainCategoryId(newValue),
    dataMerchants,
    merchant,
    handleMerchantChange,
    dataMainGroup,
    dataMasterMainGroup,
    handleRefetchData,
  };
};
export default useCategoryController;
